<span class='_load-animate' [class._load-active]="loading">
	<div mat-dialog-title class="_pay-dialog-title">
		<span class="_cap">{{ 'EX_PAYMENT_MODAL' | translate }}</span>
		<button mat-icon-button mat-dialog-close cdkFocusInitial>
			<mat-icon aria-label="Close Dialog">close</mat-icon>
		</button>
	</div>

	<div mat-dialog-content style="max-height: none">

		<div id="ex-payment-div"></div>

		<div class="shadow-lg my-3 p-3" style="border-radius: 20px">
			<h4 class="text-center mb-3">Enter card details</h4>
			<div id="dv-mount" [class._avs]="hasAVS"></div>

			<!-- (Optional) 3-D Secure challenge container if you enable 3DS -->
			<div id="threeDS-container" class="card" style="display:none;"></div>

			<button mat-raised-button color="accent" class="lg rounded btn-block" type="button"
					(mousedown)="onPaymentClicked()">
				<div class="d-flex justify-content-between align-items-center" style="gap:15px">
					<span>{{ 'PAY' | translate }}</span>
					<span>{{ data.total | lcurrency }}</span>
				</div>
			</button>
		</div>

		<div class="provider-logo">
			<img [src]="'assets/images/vendors/magensa.png'">
		</div>

		<!--
		<ul class="text-danger" style="font-size: 11px;">
			@for (m of debugMessages; track m) {
				<li>{{ m }}</li>
			}
		</ul>-->


	</div>
</span>

